import styled from 'styled-components';
import { DualFieldWrapper } from '../../pages/Register/TaxInformation/TaxInformation.styles';
import { theme } from '../../styling/theme';

const Wrapper = styled.div`
  padding-right: ${props => theme(props).SIZE.MEDIUM};
  padding-left: ${props => theme(props).SIZE.MEDIUM};

  & .MuiNativeSelect-select {
    color: black;
  }
`;

export default {
  DualFieldWrapper,
  Wrapper,
};
